export const addMonths = (date: Date, months: number) => {
  const now = new Date(date)
  const month = now.getMonth()
  return new Date(now.setMonth(month + months))
}
